import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { useParams } from "react-router-dom";
import { AddTrainingComponentsTrainingModulesModel } from "./AddComponentsTrainingModules_model";
import { TrainingComponentsGrid } from "../../../TrainingComponentsGrid/TrainingComponentsGridView_view";

export const AddTrainingComponentsTrainingModulesGrid: React.FC<{
  trainingModulesIds: number[];
  assignedComponentsIds?: number[];
  onAssignSuccess?: (selectedComponents: number) => void;
}> = observer(({ trainingModulesIds, assignedComponentsIds, onAssignSuccess }) => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams<{ projectId: string }>();

  const [model] = useState(
    () =>
      new AddTrainingComponentsTrainingModulesModel(
        organisationId,
        +projectId,
        trainingModulesIds,
        onAssignSuccess,
        assignedComponentsIds
      )
  );

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex flex-column unassigned-components-grid h-100">
        <div className="insight-tab-content__space-filler h-100">
          <TrainingComponentsGrid
            gridToolbarType="link-modal"
            onAssignSuccess={model.addTrainingComponentsToTrainingModules}
            data={model.components}
            isLoading={model.isLoading}
            // columnDefs={model.componentsColDefs}
            // refreshDataHandler={undefined}
            onFieldUpdate={model.loadAllComponents}
            preSelectedItemIds={model.assignedComponentsIds ? model.assignedComponentsIds : []}
          />
        </div>
      </div>
    </div>
  );
});
